import { Button } from "@mui/joy";
import { debounce } from "lodash";
import useOpenNewMeditationRecord from "hooks/useOpenNewMeditationRecord";
import { AddIcon } from "static/image/common/IconAssets";
import useIsRecordSeparatedPage from "hooks/useIsRecordSeparatedPage";
import useIsInappWebview from "hooks/useIsInappWebview";
import { generateRecordKey } from "logic/logics";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { useNavigate } from "react-router-dom";
import { MeditationGroupType } from "api/meditationRecordApi";

export default function AddNewMeditationRecordButton({
  disabled,
  groupType = "routine",
}: {
  disabled: boolean;
  groupType?: MeditationGroupType;
}) {
  const userState = useRecoilValue(userAtom);
  const isRecordSeparatedPage = useIsRecordSeparatedPage();
  const isTaskContainerSmall = useIsInappWebview();
  const navigate = useNavigate();

  const openNewMeditationRecord = useOpenNewMeditationRecord(groupType);

  const debouncedOnClick = debounce(() => {
    if (isRecordSeparatedPage) {
      const meditationRecordKey = generateRecordKey(
        userState?.userId!!,
        "meditation"
      );
      const sp = new URLSearchParams();
      sp.set("mrk", meditationRecordKey);
      if (groupType) sp.set("groupType", groupType);
      navigate(`/meditation-record-detail?${sp.toString()}`);
    } else {
      openNewMeditationRecord();
    }
  }, 100);

  return (
    <Button
      fullWidth
      onClick={debouncedOnClick}
      size={isTaskContainerSmall && !isRecordSeparatedPage ? "sm" : "lg"}
      variant="Soft"
      sx={{
        minWidth: 0,
        paddingInline: 0,
        ...(isTaskContainerSmall &&
          !isRecordSeparatedPage && { width: "64px", "--Button-gap": 0 }),
        ...((!isTaskContainerSmall || isRecordSeparatedPage) && {
          "--Button-gap": "4px",
        }),
      }}
      disabled={disabled}
      startDecorator={<AddIcon size={16} />}
    >
      {(!isTaskContainerSmall || isRecordSeparatedPage) && "훈련하기"}
    </Button>
  );
}
